import { History } from "history";

import {
  GET_STUDENTS,
  GET_STUDENTS_ERROR,
  GET_STUDENTS_SUCCESS,
  GET_STUDENTS_V2,
  GET_STUDENTS_V2_ERROR,
  GET_STUDENTS_V2_SUCCESS,
  GetStudentsAction,
  GetStudentsErrorAction,
  GetStudentsSuccessAction,
  GetStudentsV2Action,
  GetStudentsV2ErrorAction,
  GetStudentsV2SuccessAction,
} from "./actionTypes";
import { PaginateQuery, StudentDto, StudentV2Dto } from "../../../interfaces";
import { Paginated } from "../../../models";

//#region Get Students

export const getStudents = (
  request: PaginateQuery,
  history: History
): GetStudentsAction => {
  return {
    type: GET_STUDENTS,
    payload: { request, history },
  };
};

export const getStudentsSuccess = (
  response: Paginated<StudentDto>
): GetStudentsSuccessAction => {
  return {
    type: GET_STUDENTS_SUCCESS,
    payload: response,
  };
};

export const getStudentsError = (error: any): GetStudentsErrorAction => {
  return {
    type: GET_STUDENTS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Students V2

export const getStudentsV2 = (
  request: PaginateQuery,
  history: History
): GetStudentsV2Action => {
  return {
    type: GET_STUDENTS_V2,
    payload: { request, history },
  };
};

export const getStudentsV2Success = (
  response: Paginated<StudentV2Dto>
): GetStudentsV2SuccessAction => {
  return {
    type: GET_STUDENTS_V2_SUCCESS,
    payload: response,
  };
};

export const getStudentsV2Error = (error: any): GetStudentsV2ErrorAction => {
  return {
    type: GET_STUDENTS_V2_ERROR,
    payload: error,
  };
};

//#endregion
